module.exports = __webpack_public_path__ + "static/media/coupon_campaign_type.5d39217a.png";